<div class="container" [class.tablet]="isTablet" [class.mobile]="isMobile">
  <div class="main-title">News</div>
  <div class="admin" *ngIf="isAdmin">
    <button class="wire-btn skalaki" (click)="newsModal(newsTemplate)">Add News</button>
  </div>
  <div class="last-article" *ngIf="lastArticle" [class.mobile]="isMobile"
    (click)="newsModal(newsTemplate, lastArticle)">
    <div class="picture">
      <img *ngIf="lastArticle.picture" [src]="lastArticle.picture.path" alt="Picture"
        [hidden]="!lastArticle.picture.loaded" (load)="lastArticle.picture.loaded = true" />
    </div>
    <div class="info">
      <div class="date">
        {{lastArticle.createdAt | date:'dd/MM/yyyy'}}
      </div>
      <div class="title">
        {{getProperty(lastArticle, 'title')}}
      </div>
      <div class="description" [innerHTML]="getProperty(lastArticle, 'description')">
      </div>
    </div>
  </div>
  <div class="articles-container" [class.mobile]="isMobile">
    <div class="article" *ngFor="let article of articles" [class.mobile]="isMobile" [class.tablet]="isTablet"
      (click)="newsModal(newsTemplate, article)">
      <div class="picture">
        <img *ngIf="article.picture" [src]="article.picture.path" alt="Picture" [hidden]="!article.picture.loaded"
          (load)="article.picture.loaded = true" />
      </div>
      <div class="info">
        <div class="date">
          {{article.createdAt | date:'dd/MM/yyyy'}}
        </div>
        <div class="title">
          {{getProperty(article, 'title')}}
        </div>
        <div class="description" [innerHTML]="getProperty(article, 'description')">

        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #newsTemplate>
  <div class="modal-content">
    <div class="header">
      <span *ngIf="!newsModel.id">Add</span><span *ngIf="newsModel.id">Edit</span> Event
      <div class="close" (click)="close()">
        <i class="fa fa-times"></i>
      </div>
    </div>
    <div class="content">
      <div class="form">
        <div class="form-group">
          <div class="label">Title Fr</div>
          <input type="text" required id="titleFr" [(ngModel)]="newsModel.titleFr" #titleFr="ngModel" />
          <div *ngIf="titleFr.invalid && (titleFr.dirty || titleFr.touched)">
            Title fr is required
          </div>
        </div>
        <div class="form-group">
          <div class="label">Title En</div>
          <input type="text" required id="titleEn" [(ngModel)]="newsModel.titleEn" #titleEn="ngModel" />
          <div *ngIf="titleEn.invalid && (titleEn.dirty || titleEn.touched)">
            Title en is required
          </div>
        </div>
        <div class="form-group">
          <div class="label">Description Fr</div>
          <textarea type="text" required id="descriptionFr" [(ngModel)]="newsModel.descriptionFr"
            #descriptionFr="ngModel" rows="8"></textarea>
          <div *ngIf="descriptionFr.invalid && (descriptionFr.dirty || descriptionFr.touched)">
            Description fr is required
          </div>
        </div>
        <div class="form-group">
          <div class="label">Description En</div>
          <textarea required id="descriptionEn" [(ngModel)]="newsModel.descriptionEn" #descriptionEn="ngModel"
            rows="8"></textarea>
          <div *ngIf="descriptionEn.invalid && (descriptionEn.dirty || descriptionEn.touched)">
            Description en is required
          </div>
        </div>
        <div class="form">
          <div class="form-group">
            <div class="label">Picture</div>
            <input type="file" (change)="onFileChange($event)">
          </div>
        </div>
        <div class="file" *ngIf="newsModel.picture">
          <div class="file-name" *ngIf="newsModel.picture.file">
            {{newsModel.picture.file.name}}
          </div>
          <div class="file-name" *ngIf="newsModel.id && !newsModel.picture.file">
            {{getPictureName(newsModel.picture.path)}}
          </div>
          <div class="icon" (click)="removePictureFromNews(newsModel.picture)">
            <i class="fa fa-times"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <button class="wire-btn" (click)="saveNews()">Save</button>
      <button *ngIf="newsModel.id" class="wire-btn" (click)="deleteNews()">Delete</button>
      <button class="wire-btn default" (click)="close()">Cancel</button>
    </div>
  </div>
</ng-template>

<p-confirmDialog header="Delete News" icon="pi pi-exclamation-triangle"></p-confirmDialog>